export default "__VITE_ASSET__CKLQhP8c__"